import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';

import {
  MatPaginatorModule,
  MatInputModule,
  MatDialogModule,
  MatButtonModule,
  MatIconModule,
  MatDatepickerModule,
  MatNativeDateModule
} from '@angular/material';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LovComponent } from './lov/lov.component';
import { MktglayoutComponent } from './_layout/mktglayout.component';
import { BudgetentryComponent } from './budgetentry/budgetentry.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ExcelUploadComponent } from './excel-upload/excel-upload.component';
import { PopmktgComponent } from './popmktg/popmktg.component';
import { ExcelService } from './excelservices/excel.service';
import { LoginComponent } from './login/login.component';
import { FoCostCenterComponent } from './fo-cost-center/fo-cost-center.component';
import { Mktgp001Component } from './reports/mktgp001/mktgp001.component';
import { Mktgp006Component } from './reports/mktgp006/mktgp006.component';
import { Mktgp004Component } from './reports/mktgp004/mktgp004.component';
import { Mktgp002Component } from './reports/mktgp002/mktgp002.component';
import { Mktgp003Component } from './reports/mktgp003/mktgp003.component';
import { Mktgp005Component } from './reports/mktgp005/mktgp005.component';
import { PrintReportComponent } from './reports/print-report/print-report.component';

@NgModule({
  declarations: [
    AppComponent,
    LovComponent,
    MktglayoutComponent,
    PopmktgComponent,
    BudgetentryComponent,
    LoginComponent,
    Mktgp001Component,
    PrintReportComponent,
    Mktgp006Component,
    Mktgp004Component,
    Mktgp002Component,
    Mktgp003Component,
    Mktgp005Component,
    DashboardComponent,
    ExcelUploadComponent,
    FoCostCenterComponent
    
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatTableModule,
    MatPaginatorModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule

  ],
  exports: [
    MatTableModule,
    MatPaginatorModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule
  ],
  providers: [ExcelService],
  bootstrap: [AppComponent],
  entryComponents: [LovComponent]
})
export class AppModule { }
